module.exports = __webpack_public_path__ + "static/media/spoon.54fce9bd.jpg";